import AgentCreateResponse from "../../views/AgentOnBoarding/AgentCreateResponse";
import WsService from "../WsService";
import RawWsService from "../RawWsService";
import AgentSearchResponse from "../../views/AgentOnBoarding/AgentSearchResponse";
import AgentRetrieveResponse from "../../views/AgentOnBoarding/AgentRetrieveResponse";


const ENDPOINT_BASE = "/admin/agents";

export default class ManagedAgentService {
    static createManagedAgent(payload, managerId, registeringPartnerId, channelId) {

        let endpoint = ENDPOINT_BASE + "/" + managerId

        let headers = {
            'registering-partner-id': registeringPartnerId,
            'registering-channel-id': channelId
        };
        return WsService.postWithHeaders(endpoint, payload, 201, headers).then(
            response => {
                return new AgentCreateResponse(response);
            },
            err => {
                return err;
            }
        )
    }

    static searchManagedAgents(search, managerId, headers) {

        let endpoint = ENDPOINT_BASE + "/" + managerId + "?search=" + search

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let array = [];
                response.body.forEach(response => {
                    array.push(new AgentSearchResponse(response))
                });
                return {"headers": response.headers, "body": array};
            },
            response => {
                return response;
            }
        )

    }

    static retrieveById(agentId) {

        let endpoint = ENDPOINT_BASE + "/" + agentId;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new AgentRetrieveResponse(response);
            },
            response => {
                return response;
            });
    }
}